import React, {useContext, useState, useEffect} from 'react'
import {Link, useHistory} from 'react-router-dom'
import axios from 'axios'

import {ExpandableSection, Tabs, TabsPanel, Button, IconSettings} from '@salesforce/design-system-react';

import PanelGroup from '../components/PanelGroup'
import SalesforceConfigTable from '../components/SalesforceConfigTable'
import SalesforceConfigExtra from '../components/SalesforceConfigExtra'

import {AppContext} from '../context/appContext'

function Settings() {
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)

  const {jwt} = useContext(AppContext)

  const history = useHistory();
  
  // useEffect(() => {
  //   const getSettings = async () => {
	// 		setIsError(false);
  //     setIsLoading(true);
 
  //     try {
	// 			const result = await axios({
	// 				method: 'post',
	// 				url: '/salesforce/api/search.json',
	// 				data: {
  //           jwt: jwt,
	// 					terms: 'inputValue'
	// 				}
	// 			})
	// 		} catch (error) {
	// 			console.log(error)
  //       setIsError(true)
  //     }
  //     setIsLoading(false)
  //   }
  //   getSettings()
  // }, [])

  const handleAdd = () => {
    // create new salesforce object 
    const getSettings = async () => {
			setIsError(false);
      setIsLoading(true);
 
      try {
				const result = await axios({
					method: 'post',
          url: '/api/plugin_objects',
          data: {
            jwt: jwt
          }
        })
        console.log("url: '/api/plugin_objects'")
        console.log(result)
        history.push(`/mappings/${result.data.id}`)
			} catch (error) {
				console.log(error)
        setIsError(true)
      }
      setIsLoading(false)
    }
    getSettings()
  }
  
  return (
    <IconSettings iconPath="/icons">
      <Tabs id="tabs">
        <TabsPanel label="Salesforce Settings">
          <ExpandableSection
            id="controlled-expandable-section-1"
            title="Object Options"
          >
            <PanelGroup addLabel="Add New" onAdd={handleAdd} removeAll={false}>
              <SalesforceConfigTable />
            </PanelGroup>
          </ExpandableSection>
          <hr className="narrow-line" />
          <ExpandableSection
            id="controlled-expandable-section-2"
            title="Case Settings"
          >
            <SalesforceConfigExtra />
          </ExpandableSection>
          <footer className="slds-modal__footer">
          <Link to="/"><Button label="Done" /></Link>
          </footer>
        </TabsPanel>
      </Tabs>
    </IconSettings>
  )
}

export default Settings